import type { SupportedLocaleType } from '@pushflow/constants'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { loadLocalizationResources } from '.'

export const initI18n = async (lang: SupportedLocaleType) => {
  await i18n.use(initReactI18next).init({
    resources: {
      [lang]: {
        translation: await loadLocalizationResources(lang),
      },
    },
    lng: lang as string,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === 'yesno') {
          if (lng === 'ru') {
            return value ? 'Да' : 'Нет'
          }
          return value ? 'Yes' : 'No'
        }

        return value as string
      },
    },
  })

  return i18n
}
